import apiClient from '../utils/apiClient';

export const loyaltyAPI = {
  // ── Programs ──────────────────────────────────────────────────────────────

  getPrograms: async (params = {}) => {
    return apiClient.get({ url: '/loyalty/programs/all', params });
  },

  createProgram: async (data) => {
    return apiClient.post({ url: '/loyalty/programs', data });
  },

  updateProgram: async (id, data) => {
    return apiClient.put({ url: `/loyalty/programs/${id}`, data });
  },

  updateProgramStatus: async (id, status) => {
    return apiClient.patch({ url: `/loyalty/programs/${id}/status`, data: { status } });
  },

  copyProgram: async (id, branchId) => {
    return apiClient.post({ url: `/loyalty/programs/${id}/copy`, data: { branch_id: branchId ?? null } });
  },

  // ── Participations ────────────────────────────────────────────────────────

  getParticipations: async (params = {}) => {
    return apiClient.get({ url: '/loyalty/participations', params });
  },

  approveParticipation: async (id, orderItemId) => {
    return apiClient.patch({
      url: `/loyalty/participations/${id}/review`,
      data: { action: 'approve', orderItemId },
    });
  },

  rejectParticipation: async (id, rejectedReason) => {
    return apiClient.patch({
      url: `/loyalty/participations/${id}/review`,
      data: { action: 'reject', rejectedReason },
    });
  },
};
